import { detectionsConstants } from '../constants'

const initialState = {
  list: null,
  lots: null,
  inspectors: null,
  maintainers: null,
  error: null,
  loading: false
}

export default function detections(state = initialState, action) {
  switch (action.type) {
    case detectionsConstants.LOADING_LOTS:
      return { ...state, loading: true, list: null, lots: null, error: null }
    case detectionsConstants.LOADING_LOTS_SUCCESS:
      return { ...state, lots: action.payload, loading: false }
    case detectionsConstants.LOADING_LOTS_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case detectionsConstants.UPDATING_LOTS:
      return { ...state, loading: true, error: null }
    case detectionsConstants.UPDATING_LOTS_SUCCESS:
      return { ...state, loading: false, lots: action.payload, error: null }
    case detectionsConstants.UPDATING_LOTS_FAILURE:
      return { ...state, loading: false, error: null }
    case detectionsConstants.LOADING_DETECTIONS:
      return {
        ...state,
        loading: true,
        lots: null,
        list: null,
        inspectors: null,
        maintainers: null,
        error: null
      }
    case detectionsConstants.LOADING_DETECTIONS_SUCCESS:
      return { ...state, loading: false, ...action.payload, error: null }
    case detectionsConstants.LOADING_DETECTIONS_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case detectionsConstants.ASSIGNING_LOT:
      return { ...state, loading: true }
    case detectionsConstants.ASSIGN_LOT_SUCCESS:
      return { ...state, ...action.payload, loading: false, error: null }
    case detectionsConstants.ASSIGN_LOT_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case detectionsConstants.UPDATING_LOT_PERSON:
      return { ...state, loading: true, error: null }
    case detectionsConstants.UPDATING_LOT_PERSON_SUCCESS:
      return { ...state, loading: false, ...action.payload, error: null }
    case detectionsConstants.UPDATING_LOT_PERSON_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case detectionsConstants.CHANGE_RESOLVED_STATUS:
      return { ...state, loading: true }
    case detectionsConstants.CHANGE_RESOLVED_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: state.list.map((x) =>
          x.id === action.payload.id ? action.payload : x
        )
      }
    case detectionsConstants.CHANGE_RESOLVED_STATUS_FAILURE:
      return { ...state, loading: false }
    case detectionsConstants.RESET_ALL:
      return initialState
    default:
      return state
  }
}
